




















import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ParentComponentMixin from '@/common/ts/child-component/ParentComponentMixin';
import ChildComponentCollection from '@/common/ts/child-component/ChildComponentCollection';
import MetaNavigationFlyoutLink from '@/webcomponents/header/MetaNavigationFlyoutLink.vue';

const ArrowRightIcon = () => import('@/common/icons/arrow-right.svg');

const FLYOUT_LINK_TAG_NAME = 'BRANDHUB-META-NAVIGATION-FLYOUT-LINK';
const LOGIN_CLOSE_EVENT = 'on-login-close';

@Component({
  components: {
    ArrowRightIcon,
  },
})
export default class LoginFlyout extends mixins(Vue, ParentComponentMixin) {
  $refs!: {
    links: HTMLElement;
  };

  links: ChildComponentCollection<MetaNavigationFlyoutLink> = new ChildComponentCollection<MetaNavigationFlyoutLink>();
  linksVisible = false;
  linkHeight = 56;

  created () {
    this.initParentComponentMixin(
      this.links,
      ['MetaNavigationFlyoutLink'],
      this.onLinkAdded,
    );
  }

  onLinkAdded (addedItem: Vue) {
    const linkItem = addedItem as MetaNavigationFlyoutLink;
    if (linkItem.index === 0) {
      linkItem.isFirstItem = true;
      (linkItem.$el as HTMLElement).focus();
    }
  }

  mounted () {
    window.addEventListener('click', this.closeOnOutsideClick, { passive: true });
  }

  closeOnOutsideClick (evt: Event) {
    const clickedElement = evt.composedPath().shift();
    if (clickedElement && !this.$el.contains(clickedElement as Node)) {
      this.$emit(LOGIN_CLOSE_EVENT);
    }
  }

  onLoginClicked () {
    this.linksVisible = !this.linksVisible;
    if (this.linksVisible) {
      this.$refs.links.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onTab () {
    setTimeout(() => {
      const { activeElement } = (this.$el.getRootNode() as Document);
      if (activeElement && activeElement.tagName !== FLYOUT_LINK_TAG_NAME) {
        this.$emit(LOGIN_CLOSE_EVENT);
      }
    }, 0);
  }

  beforeDestroy () {
    window.removeEventListener('click', this.closeOnOutsideClick);
  }

  get loginIconClass () {
    return {
      'brandhub-login-flyout__icon--up': this.linksVisible,
    };
  }

  get linksClass () {
    return {
      'brandhub-login-flyout__links--visible': this.linksVisible,
    };
  }

  get linksStyle () {
    return {
      '--links-height': `${this.linkHeight * this.links.length}px`,
    };
  }
}
